import React from 'react';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import {
  getVolcanoEvents as getVolcanoEventsAc,
  clearVolcanoEvents as clearVolcanoEventsAc,
  clearVolcanoEventRedirect as clearVolcanoEventRedirectAc,
} from '../../../../../../redux/volcanoes/event/search/volcanoEventSearchActions';
import {
  deleteVolcanoEvent as deleteVolcanoEventAc,
  clearVolcanoEventData as clearVolcanoEventDataAc,
  getRegions as getRegionsAc,
  sortData as sortDataAc,
  toggleColumns as toggleColumnsAc,
} from '../../../../../../redux/volcanoes/event/data/volcanoEventDataActions';
import { isDataManager } from '../../../../../../role/roleUtils';
import { SearchParamDisplay } from '../../../../../data/SearchParamDisplay';
import { resolveSearchParameters } from '../search/volcanoEventSearchParameterNameResolver';
import { Loading } from '../../../../../loadbar/Loading';
import { VolcanoEventDataGrid } from './VolcanoEventDataGrid';

class VolcanoContainerUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.toggleDescriptionModal = this.toggleDescriptionModal.bind(this);
    // this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.state = {
      queryParameters: {},
    };
  }


  componentDidMount() {
    document.title = 'NCEI Hazard Volcano Event Results';
    const {
      getVolcanoEvents,
      clearVolcanoEventRedirect,
      searchRedirect,
      clearVolcanoEventData,
      getRegions,
      location: { search },
      history,
    } = this.props;
    clearVolcanoEventData();
    getRegions({ history });
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    if (!searchRedirect) {
      getVolcanoEvents({ queryParameters, history });
    } else {
      clearVolcanoEventRedirect();
    }
    this.setState({ queryParameters });
  }

  componentWillUnmount() {
    const { clearVolcanoEvents, clearVolcanoEventData } = this.props;
    clearVolcanoEvents();
    clearVolcanoEventData();
  }

  toggleDescriptionModal(name) {
    this.setState(state => ({ modals: state.modals.update(name, val => !val) }));
  }

  render() {
    const {
      volcanoEvents,
      fetched,
      deleting,
      authorities,
      regions,
      peopleDescriptors,
      damageDescriptors,
      sort,
      visibleColumns,
      history,
      deleteVolcanoEvent,
      getVolcanoEvents,
      toggleColumns,
      sortData,
    } = this.props;
    const { queryParameters } = this.state;

    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters, regions, peopleDescriptors, damageDescriptors,
    });

    return (
      <div className="haz-results-container haz-page-container">
        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}

        <div className="haz-data-grid-container">
          <div className="haz-data-grid-container">
            <Card>
              <CardBody>
                <div className="doiCitation">
                  <span id="doiReference">
                    <p>
                      <a href="http://dx.doi.org/10.7289/V5JW8BSH" rel="noopener noreferrer" target="_blank" title="Earthquake DOI Information" aria-label="Earthquake DOI Information">Please cite DOI:10.7289/V5JW8BSH</a>
                    </p>
                  </span>
                </div>

                <CardTitle tag="h2">{`Volcano Events - ${volcanoEvents.size} Results Found`}</CardTitle>
                <VolcanoEventDataGrid
                  volcanoEvents={volcanoEvents}
                  dataManager={dataManager}
                  sort={sort}
                  visibleColumns={visibleColumns}
                  toggleColumns={toggleColumns}
                  sortData={sortData}
                  searchParams={JSON.stringify(sp)}
                  deleting={deleting}
                  deleteVolcanoEvent={deleteVolcanoEvent}
                  history={history}
                  onDeleteCloseModal={() => getVolcanoEvents({ queryParameters, history })}
                />
              </CardBody>
            </Card>
          </div>
        </div>


      </div>
    );
  }
}

VolcanoContainerUnwrapped.propTypes = {
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  volcanoEvents: ImmutablePropTypes.list.isRequired,
  getVolcanoEvents: PropTypes.func.isRequired,
  clearVolcanoEvents: PropTypes.func.isRequired,
  deleteVolcanoEvent: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  clearVolcanoEventRedirect: PropTypes.func.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  clearVolcanoEventData: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['volcanoEventSearch', 'fetched']),
    state.getIn(['volcanoEventDataPage', 'fetchedRegions']),
  ].every(v => v),
  deleting: state.getIn(['volcanoEventDataPage', 'deleting']),
  volcanoEvents: state.getIn(['volcanoEventSearch', 'items']),
  searchRedirect: state.getIn(['volcanoEventSearch', 'searchRedirect']),
  regions: state.getIn(['volcanoEventDataPage', 'regions']),
  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  sort: state.getIn(['volcanoEventSearch', 'sort']),
  visibleColumns: state.getIn(['volcanoEventDataPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getVolcanoEvents: getVolcanoEventsAc,
  clearVolcanoEvents: clearVolcanoEventsAc,
  deleteVolcanoEvent: deleteVolcanoEventAc,
  clearVolcanoEventRedirect: clearVolcanoEventRedirectAc,
  clearVolcanoEventData: clearVolcanoEventDataAc,
  getRegions: getRegionsAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
}, dispatch);


export const VolcanoContainer = connect(mapStateToProps, mapDispatchToProps)(VolcanoContainerUnwrapped);
